module.exports = __webpack_public_path__ + "svg/viel_platz.svg";